import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type UriInput from './uri-input.vue'

export const httpUriOptions = [
  {
    label: 'Https://',
    value: 'https://',
  },
  {
    label: 'Http://',
    value: 'http://',
  },
]

export const getHttpMethodUri = (uri: string | null) => {
  let prefix = 'https://'
  let url = uri ? uri : ''
  const currentUri = uri ? uri.toLowerCase() : ''
  try {
    const urlObject = new URL(currentUri)
    if (!prefix.includes(urlObject.protocol)) {
      prefix = 'http://'
    }
    url = currentUri.replace(prefix, '')
  } catch (error) {
    // Ignore the error
  }
  return {
    prefix,
    url,
  }
}

export const uriInputProps = buildProps({
  value: {
    type: [String, null],
    default: '',
  },
  suffix: {
    type: String,
    default: '',
  },
  // 后缀值
  addonAfter: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '请输入',
  },
  // 显示复制
  showCopy: {
    type: Boolean,
    default: true,
  },
} as const)

export const uriInputEmits = {
  'update:value': (value: string) => typeof value === 'string',
  change: (value: string) => typeof value === 'string',
}

// props
export type UriInputProps = ExtractPropTypes<typeof uriInputProps>

// emits
export type UriInputEmits = typeof uriInputEmits

// instance
export type UriInputInstance = InstanceType<typeof UriInput>
